<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>NAAC Metric Number Selection</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" size="small" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
      <div class="college-logo-container" *ngIf="showCollegeLogo && collegeLogo">
        <img [src]="collegeLogo" alt="College Logo" class="college-logo-image" />
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="container pt-3">
      <!-- <div class="card-header" style="font-size: 13px;">
        <strong>SUGGESTED METRICS</strong>
      </div>
      <div class="card-body segment-label p-1 ml-2">
        <div class="card-body" *ngIf="!(showQnM || showQlM)" >No Applicable metric available</div>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Quantitative Metrics &nbsp;</li>
        </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.UG.length != 0">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.UG; let i = index">
                <span (click)="openEsupport(matricId, 'UG')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.PG.length != 0">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.PG; let i = index">
              <span (click)="openEsupport(matricId, 'PG')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AU.length != 0">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AU; let i = index">
                <span (click)="openEsupport(matricId, 'AU')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.CU.length != 0">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.CU; let i = index">
                <span (click)="openEsupport(matricId, 'CU')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AC.length != 0">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AC; let i = index">
                <span (click)="openEsupport(matricId, 'AC')">{{matricId}}</span>
            </li>
          </ul>

          <ul class="list-inline mt-1 mb-1 separator">
            <li class="list-inline-item ">&nbsp;</li>
          </ul>

        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Qualitative Metrics &nbsp;</li>
        </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.UG">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.UG; let i = index">
                <span (click)="openQlMEsupport(matricId, 'UG')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.PG">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.PG; let i = index">
              <span (click)="openQlMEsupport(matricId, 'PG')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AU">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AU; let i = index">
                <span (click)="openQlMEsupport(matricId, 'AU')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.CU">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp; </li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.CU; let i = index">
                <span (click)="openQlMEsupport(matricId, 'CU')">{{matricId}}</span>
            </li>
          </ul>
          <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AC">
            <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp; </li>
            <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AC; let i = index">
                <span (click)="openQlMEsupport(matricId, 'AC')">{{matricId}}</span>
            </li>
          </ul>
      </div> -->
      <ion-segment (ionChange)="metricSegmentChanged($event)" value="SUGGESTED" class="border">
        <ion-segment-button value="SUGGESTED" size="12">
          <ion-label>SUGGESTED</ion-label>
          </ion-segment-button>
        <ion-segment-button value="OTHER">
          <ion-label>OTHER</ion-label>
          <div *ngIf="showOther">
          </div>
        </ion-segment-button>
      </ion-segment>
      <div *ngIf="showSuggested" class="p-2 border">
        <div class="card-body" *ngIf="!(showQnMSuggested || showQlMSuggested)">No applicable metric available</div>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Quantitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested && eSupportMapping.UG.length != 0 && form.collegeType=='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.UG; let i = index">
            <span (click)="openEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested && eSupportMapping.PG.length != 0 && form.collegeType=='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.PG; let i = index">
            <span (click)="openEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested && eSupportMapping.AU.length != 0 && form.collegeType=='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AU; let i = index">
            <span (click)="openEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested && eSupportMapping.CU.length != 0 && form.collegeType=='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.CU; let i = index">
            <span (click)="openEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnMSuggested && eSupportMapping.AC.length != 0 && form.collegeType=='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AC; let i = index">
            <span (click)="openEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      
        <ul *ngIf="showQnMSuggested && showQlMSuggested" class="list-inline mt-1 mb-1 separator">
          <li class="list-inline-item ">&nbsp;</li>
        </ul>
      
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Qualitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.UG && form.collegeType=='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.UG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.PG && form.collegeType=='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.PG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.AU && form.collegeType=='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.CU && form.collegeType=='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.CU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlMSuggested && eSupportMapping.qlm.AC && form.collegeType=='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AC; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      </div>
      <div *ngIf="showOther" class="p-2 border">
        <div class="card-body" *ngIf="!(showQnM || showQlM)">No applicable metric available</div>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Quantitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.UG.length != 0 && form.collegeType !='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.UG; let i = index">
            <span (click)="openEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.PG.length != 0 && form.collegeType !='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.PG; let i = index">
            <span (click)="openEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AU.length != 0 && form.collegeType !='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AU; let i = index">
            <span (click)="openEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.CU.length != 0 && form.collegeType !='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.CU; let i = index">
            <span (click)="openEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQnM && eSupportMapping.AC.length != 0 && form.collegeType !='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.AC; let i = index">
            <span (click)="openEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      
        <ul *ngIf="showQnM && showQlM" class="list-inline mt-1 mb-1 separator">
          <li class="list-inline-item ">&nbsp;</li>
        </ul>
      
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM">
          <li class="list-inline-item"><i class="fab fa-dot"></i> &nbsp;Qualitative Metrics &nbsp;</li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.UG && form.collegeType !='UG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;UG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.UG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'UG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.PG && form.collegeType !='PG'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;PG &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.PG; let i = index">
            <span (click)="openQlMEsupport(matricId, 'PG')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AU && form.collegeType !='AU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.CU && form.collegeType !='CU'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;CU &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.CU; let i = index">
            <span (click)="openQlMEsupport(matricId, 'CU')">{{matricId}}</span>
          </li>
        </ul>
        <ul class="list-inline mt-1 mb-1" *ngIf="showQlM && eSupportMapping.qlm.AC && form.collegeType !='AC'">
          <li class="list-inline-item mr-4"><i class="fab fa-wpforms"></i> &nbsp;AC &nbsp;&nbsp;&nbsp;</li>
          <li class="list-inline-item" *ngFor="let matricId of eSupportMapping.qlm.AC; let i = index">
            <span (click)="openQlMEsupport(matricId, 'AC')">{{matricId}}</span>
          </li>
        </ul>
      </div>
    <div id="selected-numbers" class="separator mt-2">
      <div class="card">
        <div class="card-header">
          Applied Numbers
        </div>
        <div class="card-body">
          <span class="badge rounded-pill bg-light text-dark" style="width: 77px;margin: 14px;" *ngFor="let number of selectedMetricNumberList">
            {{number}}
          </span>
          <span class="badge rounded-pill bg-warning text-dark" style="width: 77px;margin: 14px;" *ngIf="selectedMetricNumberList.length < 1">
            No number yet applied!
          </span>
        </div>
      </div>
      
    </div>

    <div class="separator">
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="checkbox" value="NA"  id="na" [(ngModel)]="naOption" (change)="onCheckboxChange($event, 'NA')">
        <label class="form-check-label" for="na">
          Not Applicable
        </label>
      </div>
      <div *ngIf="!naOption" class="form-check form-check-inline pt-3">
        <input class="form-check-input" type="checkbox" value="Undecided"  id="undecided"  [(ngModel)]="undecidedOption" 
            (change)="onCheckboxChange($event, 'Undecided')"  [checked]="selectedMetricNumberList.includes('Undecided')">
        <label class="form-check-label" for="undecided">
          Undecided
        </label>
      </div>
    </div>

    <div *ngIf="!naOption" class="pb-5">
      <div *ngFor="let mapping of metricNumbersMapping" class="pt-2 separator">
        <h6>Criteria {{mapping.criterion}}</h6>
        <div>
          <h6>Quantitative</h6>
          <div *ngFor="let number of mapping.quantitativeNumbers" class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [id]="number" [value]="number" 
                (change)="onCheckboxChange($event, number)" [checked]="selectedMetricNumberList.includes(number)">
            <!-- <label class="form-check-label" [for]="number">{{number}}</label> -->
            <span (click)="openEsupport(number, collegeType)">{{number}}</span>
          </div>
        </div>
        <div>
          <h6>Qualitative</h6>
          <div *ngFor="let number of mapping.qualitativeNumbers" class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" [id]="number" [value]="number" 
                (change)="onCheckboxChange($event, number)" [checked]="selectedMetricNumberList.includes(number)">
            <!-- <label class="form-check-label" [for]="number">{{number}}</label> -->
            <span (click)="openQlMEsupport(number, collegeType)">{{number}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- <ion-grid>
      <ion-row>
        <ion-col>
          &nbsp;
          <ion-button (click)="removeSelected(metricNumber)" fill="outline" color="primary" size="small" *ngFor="let metricNumber of selectedMetricNumberList">
            {{metricNumber.value}} &nbsp;
            <ion-icon name="close" ></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid> -->

    <!-- <div class="card">
      <div class="card-body">
          <ion-item>
            <ion-label>Undecided</ion-label>
            <ion-checkbox slot="end" [(ngModel)]="undecided.selected" (ionChange)="undecidedChanged($event)"></ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-label>NA</ion-label>
            <ion-checkbox slot="end" [(ngModel)]="na.selected" (ionChange)="naChanged($event)"></ion-checkbox>
          </ion-item>
      </div>
    </div>


    <div class="accordion" id="accordionExample">
      <div class="card" *ngFor="let criterion of metricNumberList; let metricIndex= index;">
        <div class="card-header" id="headingOne">
          <h2 class="mb-0">
            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" [attr.data-target]="'#collapseOne' + metricIndex" 
                  aria-expanded="false"  (click)="opensubCriterion(criterion)" >
                <i class="fab fa-wpforms"></i> &nbsp; {{criterion.value}}
            </button>
          </h2>
        </div>
    
        <div id="collapseOne{{metricIndex}}" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body">

            <div class="accordion" id="accordionExampleSubC">
              <div class="card" *ngFor="let subcriterion of criterion.subCriterions; let subCriterionIndex = index;">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" [attr.data-target]="'#collapseTwo' + subCriterionIndex" 
                          aria-expanded="false"  (click)="opensubCriterionOfSubCriterions(subcriterion)" >
                        <i class="fab fa-wpforms"></i> &nbsp; {{subcriterion.value}}
                    </button>
                  </h2>
                </div>
            
                <div id="collapseTwo{{subCriterionIndex}}" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExampleSubC">
                  <div class="card-body">
                      <ion-item *ngFor="let matericNumber of subcriterion.subCriterionSubCriterions">
                        <ion-label>{{matericNumber.value}}</ion-label>
                        <ion-checkbox slot="end" disabled="{{isDisabled}}"  [(ngModel)]="matericNumber.selected" (ionChange)="onSelect(matericNumber)"></ion-checkbox>
                      </ion-item>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->

</ion-content>
<ion-fab vertical="bottom" horizontal="end" slot="fixed">
  <ion-fab-button  (click)="backToForm()">
      <i class="fas fa-check"></i>
  </ion-fab-button>
</ion-fab>